/** Что за QR отсканирован: привязка E-va, настройка Wi-Fi E-va или что-то постороннее. */
export type ScannedQr = { kind: "claim"; token: string } | { kind: "wifi" } | { kind: "unknown" };

// Claim token backend'а — secrets.token_urlsafe(48), ровно 64 символа base64url (app/core/security.py).
// Мягче нельзя: иначе серийник или хэш из постороннего QR уйдёт на подтверждение привязки.
const BARE_TOKEN = /^[\w-]{64}$/;

/**
 * Разбор текста QR (ADR-005): ссылка `…/claim?token=` или голый claim token — привязка,
 * `WIFI:…` — QR точки доступа EVA-SETUP. Ссылка принимается с любого домена приложения:
 * E-va показывает публичный URL, который настроен на backend.
 */
export function parseScannedQr(text: string): ScannedQr {
  const value = text.trim();
  if (/^WIFI:/i.test(value)) return { kind: "wifi" };
  if (BARE_TOKEN.test(value)) return { kind: "claim", token: value };
  const token = claimLinkToken(value);
  return token ? { kind: "claim", token } : { kind: "unknown" };
}

function claimLinkToken(value: string): string | null {
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return null;
  }
  if (url.protocol !== "https:" && url.protocol !== "http:") return null;
  if (url.pathname.replace(/\/+$/, "").split("/").pop() !== "claim") return null;
  return url.searchParams.get("token")?.trim() || null;
}
